export type LatLon = { lat: number; lon: number };

export const parseFiniteNumber = (value?: string | number | null): number | null => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  const normalized = trimmed.replace(/,/g, '');
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
};

export const parseLatLon = (
  latitude?: string | number | null,
  longitude?: string | number | null
): LatLon | null => {
  const lat = parseFiniteNumber(latitude);
  const lon = parseFiniteNumber(longitude);
  if (lat === null || lon === null) return null;
  return { lat, lon };
};

export const metersToLatDegrees = (meters: number): number => meters / 111_320;

export const metersToLonDegrees = (meters: number, atLat: number): number =>
  meters / (111_320 * Math.cos((atLat * Math.PI) / 180));

export const computeSpiralOffsetMeters = (
  index: number,
  baseRadiusMeters = 24
): { xMeters: number; yMeters: number } => {
  // Deterministic "golden angle" spiral to avoid overlap while distributing points.
  const goldenAngleDeg = 137.508;
  const radiusMeters = baseRadiusMeters * Math.sqrt(index + 1);
  const angleRad = (index * goldenAngleDeg * Math.PI) / 180;
  const xMeters = radiusMeters * Math.cos(angleRad);
  const yMeters = radiusMeters * Math.sin(angleRad);
  return { xMeters, yMeters };
};

export const computeVirtualLatLon = (
  anchor: LatLon,
  index: number,
  baseRadiusMeters = 24
): LatLon => {
  const offset = computeSpiralOffsetMeters(index, baseRadiusMeters);
  return {
    lat: anchor.lat + metersToLatDegrees(offset.yMeters),
    lon: anchor.lon + metersToLonDegrees(offset.xMeters, anchor.lat),
  };
};

